import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import VeeValidate from 'vee-validate'
import Multiselect from 'vue-multiselect'
import UUID from 'vue-uuid'
import Vue2Filters from 'vue2-filters'
import { DatePicker, ColorPicker, Select, Option, TimeSelect } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import globalInit from '@/extensions/global_extensions'
import '@fortawesome/fontawesome-pro/css/all.css'
import 'buefy/dist/buefy.css'
import './css/main.scss'
// import './css/steps.scss'
import './css/form-styles.scss'
import './css/element-variables.scss'
import VueTheMask from 'vue-the-mask'
import money from '@/components/external/vmoney'
import VTooltip from 'v-tooltip'
import 'fix-date'
import 'nprogress/nprogress.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import VueObserveVisibility from 'vue-observe-visibility'
import Cleave from 'cleave.js'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import Viewer from 'v-viewer'
import PortalVue from 'portal-vue'
import Clipboard from 'v-clipboard'
import 'viewerjs/dist/viewer.css'
import vueSignature from 'vue-signature'
import moment from 'moment-timezone'

Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

Vue.config.productionTip = false

locale.use(lang)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Vue.use(PortalVue)
Vue.use(VTooltip)
Vue.use(UUID)
Vue.use(VeeValidate)
Vue.use(VueTheMask)
Vue.use(Buefy, {
  defaultIconPack: 'fal',
  customIconPacks: {
    fal: {
      sizes: {
        default: 'lg',
        'is-small': '',
        'is-medium': '2x',
        'is-large': '3x'
      },
      iconPrefix: 'fa-'
    }
  }
})
Vue.use(Vue2Filters)
Vue.use(DatePicker, {
  yearRange: '-100:+100'
})
Vue.use(TimeSelect)
Vue.use(Select)
Vue.use(Option)
Vue.use(ColorPicker)
Vue.component('multiselect', Multiselect)
Vue.use(money, {
  precision: 2
})
Vue.use(VueObserveVisibility)
Vue.use(Clipboard)
Vue.directive('cleave', (el, binding) => {
  const input = el.querySelector('input')
  // eslint-disable-next-line no-new
  new Cleave(input, binding.value)
})
// name is optional
Vue.use(VueLodash, { name: 'custom', lodash: lodash })
Vue.use(vueSignature)

Vue.filter('formatDate', function (value) {
  if (value) {
    if (moment.defaultZone && moment.defaultZone.name) {
      return moment.utc(String(value)).tz(moment.defaultZone.name).format('MM/DD/YYYY HH:mm')
    } else {
      return moment.utc(String(value)).format('MM/DD/YYYY HH:mm')
    }
  }
})
Vue.filter('formatDateOnly', function (value) {
  if (value) {
    if (moment.defaultZone && moment.defaultZone.name) {
      return moment.utc(String(value)).tz(moment.defaultZone.name).format('MM/DD/YYYY')
    } else {
      return moment.utc(String(value)).format('MM/DD/YYYY')
    }
  }
})

globalInit(Vue)

new Vue({
  router,
  store,
  render: (h) => h(App),
  methods: {
    isPoBox: function (addressValue) {
      if (!addressValue) {
        return false
      }
      const poBox = /^ *((#\d+)|((box|bin)[-. /\\]?\d+)|(.*p[ .]? ?(o|0)[-. /\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i
      var result = poBox.test(addressValue)
      return result
    },
    isRuralRoute: function (addressValue) {
      if (!addressValue) {
        return false
      }
      const val = addressValue.toLowerCase()
      return val.indexOf('rr ') === 0 ||
            val.indexOf('rural route') === 0 ||
            val.indexOf('rural rt') === 0 ||
            val.indexOf('rurroute') === 0 ||
            val.indexOf('ruralr') === 0 ||
            val.indexOf('rurrt') === 0
    }
    // hasControlCharacters: function (addressValue) {
    //   if (!addressValue) {
    //     return false
    //   }
    //   const controlChars = /[\x00-\x1F\x7F-\x9F]/g
    //   var result = controlChars.match(addressValue)
    //   console.log('test: ', result)
    //   return result
    // }
  },
  created: function () {
    VeeValidate.Validator.extend('address_starts_with_number', {
      // Custom validation message
      getMessage: (field) => `The ${field} field is required to start with a street number followed by the street name.`,
      // Custom validation rule
      validate: (value) => new Promise(resolve => {
        const splitValue = value.trim().split(' ')
        const numberOfTerms = splitValue.length
        const firstValue = splitValue[0]
        const secondValue = numberOfTerms > 1 ? splitValue[2] : ''
        resolve({
          valid: value && !this.isPoBox(value) && !this.isRuralRoute(value) && !isNaN(firstValue) && secondValue && isNaN(secondValue)
        })
      })
    })
    VeeValidate.Validator.extend('minimum_age_18', {
      // Custom validation message
      getMessage: (field) => 'You have to be 18 years or older in order to complete this credit application',
      // Custom validation rule
      validate: (value) => new Promise(resolve => {
        var selectedDate = new Date(value)
        var diffMs = new Date() - selectedDate.getTime()
        var ageDt = new Date(diffMs)
        var years = Math.abs(ageDt.getUTCFullYear() - 1970)
        resolve({
          valid: value && years > 17
        })
      })
    })
    // Same rules as IsSsnValid in EagLive's DTApplicantModel / DTBeneficialOwnerModel, which blanks
    // the SSN before it reaches DealerTrack. Value is masked ###-##-####.
    VeeValidate.Validator.extend('valid_ssn', {
      getMessage: (field) => `The ${field} is not a valid social security number.`,
      validate: (value) => {
        if (!value || value.length !== 11) {
          return false
        }
        const area = Number(value.substring(0, 3))
        return area !== 0 && area !== 666 && area < 900 &&
          value.substring(4, 6) !== '00' &&
          value.substring(7, 11) !== '0000'
      }
    })
  }
}).$mount('#app')
